import { useState } from 'react';

export default function useTrigger() {
    const [key, setKey] = useState(0);

    return { key, touch: () => setKey(Math.random()) };
}
